export default function Discord() {
	window.location.href = "https://discord.gg/x7DZSbFyGu";
	return null;
}